<div data-test-id="custom-date-input-container" class="tw-relative">
  <app-custom-input
    data-test-id="custom-date-input-text-input"
    [label]="label"
    [required]="required"
    [placeholder]="inputPlaceholder"
    iconUrl="/assets/images/calendar-icon.png"
    (iconClick)="picker.open()"
    (inputFocus)="inputFocus()"
    (inputBlur)="inputBlur()"
    [formControl]="control"
    [hasInputError]="hasError"
  />

  <mat-form-field data-test-id="custom-date-input-mat-form-field" class="tw-h-0 tw-w-full tw-overflow-hidden tw-block" style="display: block!important">
    @if (disableFutureDates) {
      <input data-test-id="custom-date-input-picker-input-no-future" matInput [matDatepicker]="picker" [formControl]="pickerControl" [max]="dateToday" (dateChange)="onDateChange($event)"/>
    } @else {
      <input data-test-id="custom-date-input-picker-input" matInput [matDatepicker]="picker" [formControl]="pickerControl" (dateChange)="onDateChange($event)"/>
    }
    <mat-datepicker data-test-id="custom-date-input-mat-datepicker" #picker></mat-datepicker>
  </mat-form-field>
</div>
